var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComingsoonTeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 131,
    viewBox: "0 0 135 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 131,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 130,
    rx: 9.5,
    stroke: "#3A3A3A",
    strokeOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.3704 55.6757C73.9753 55.6757 77.7082 51.9427 77.7082 47.3378C77.7082 42.733 73.9753 39 69.3704 39C64.7655 39 61.0326 42.733 61.0326 47.3378C61.0326 51.9427 64.7655 55.6757 69.3704 55.6757Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7767 49.1245H61.2268L61.2642 49.2906L61.2679 49.3049L61.3053 49.4587C62.4388 53.7552 66.8151 56.4317 71.1563 55.4827V51.5059C71.1524 50.2011 70.0799 49.1284 68.7749 49.1245H68.7767Z",
    fill: "black",
    fillOpacity: 0.098039
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9892 50.9111H61.8367C63.2145 53.8164 66.1551 55.6759 69.3706 55.6759V53.2943C69.3667 51.9893 68.294 50.9169 66.9892 50.913V50.9111Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1292 56.2706C91.5827 56.2706 94.3822 53.4711 94.3822 50.0176C94.3822 46.5642 91.5827 43.7646 88.1292 43.7646C84.6758 43.7646 81.8763 46.5642 81.8763 50.0176C81.8763 53.4711 84.6758 56.2706 88.1292 56.2706Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4891 58.0571H79.445C78.8188 58.0571 78.3035 58.5724 78.3035 59.1987V73.6874C78.2229 77.9932 81.1931 81.8015 85.3888 82.772C85.9929 82.8988 86.6083 82.9625 87.2255 82.9625C92.1295 82.9625 96.1656 78.9292 96.1688 74.0252V60.7368C96.1688 59.2668 94.9591 58.0571 93.4891 58.0571Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6636 60.7371V77.717C83.6636 85.5525 77.216 92.0001 69.3802 92.0001C64.2823 92.0001 59.5565 89.2708 57.0086 84.8551C56.6648 84.2836 56.3662 83.6862 56.1152 83.0685C55.8813 82.4859 55.6846 81.8893 55.5258 81.282C55.2312 80.1137 55.0812 78.9136 55.0791 77.7089V60.7368C55.0791 60.7358 55.0791 60.7345 55.0791 60.7334C55.0791 59.2652 56.2872 58.0571 57.7554 58.0571H80.9873C82.4555 58.0571 83.6636 59.2652 83.6636 60.7334V60.7371Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9902 50.9111H61.8377C63.2155 53.8164 66.1561 55.6759 69.3716 55.6759V53.2943C69.3677 51.9893 68.295 50.9169 66.9902 50.913V50.9111Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1579 58.0571V80.6924C71.1579 81.7981 70.3804 82.7624 69.2999 82.9971C69.1318 83.047 68.9572 83.0711 68.7818 83.0685H56.1152C55.8813 82.4859 55.6846 81.8893 55.5258 81.282C55.2312 80.1137 55.0812 78.9136 55.0791 77.7089V60.7368C55.0791 60.7358 55.0791 60.7345 55.0791 60.7334C55.0791 59.2652 56.2872 58.0571 57.7554 58.0571H71.1579Z",
    fill: "black",
    fillOpacity: 0.098039
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3714 58.0571V82.4789C69.374 82.6543 69.3498 82.8289 69.2999 82.9971C69.0653 84.0776 68.1009 84.8551 66.9952 84.8551H57.0086C56.6648 84.2836 56.3662 83.6862 56.1155 83.0685C55.8813 82.4859 55.6846 81.8893 55.5258 81.282C55.2312 80.1137 55.0812 78.9136 55.0791 77.7089V60.7368C55.0791 60.7358 55.0791 60.7345 55.0791 60.7334C55.0791 59.2652 56.2872 58.0571 57.7554 58.0571H69.3714ZM69.3714 58.0571V78.9059C69.3654 80.2072 68.2966 81.276 66.9952 81.282H55.5258C55.2312 80.1137 55.0812 78.9136 55.0791 77.7089V60.7368C55.0791 60.7358 55.0791 60.7345 55.0791 60.7334C55.0791 59.2652 56.2872 58.0571 57.7554 58.0571H69.3714ZM57.7588 58.0571C57.7578 58.0571 57.7565 58.0571 57.7554 58.0571C56.2872 58.0571 55.0791 59.2652 55.0791 60.7334V77.7089C55.0812 78.9136 55.2312 80.1137 55.5258 81.282H65.2087C66.5101 81.276 67.5789 80.2072 67.5848 78.9059V58.0571H57.7588Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3813 50.9111H65.2013C66.5076 50.9111 67.5826 51.9862 67.5826 53.2925V77.1124C67.5826 78.4187 66.5076 79.4938 65.2013 79.4938H41.3813C40.075 79.4938 39 78.4187 39 77.1124V53.2925C39 51.9862 40.075 50.9111 41.3813 50.9111Z",
    fill: "#4B53BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4032 59.7988H55.0631V74.1269H51.5545V59.7988H46.184V56.2793H60.4032V59.7988Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingsoonTeams);
export default __webpack_public_path__ + "static/media/comingsoon_teams.c5be920128bea7f4067b1ab7508ec77f.svg";
export { ForwardRef as ReactComponent };